export class LakeManyaraText {
  paragraphHeaders = [
    'Wildlife',
    'Biodiversity',
    'Tree Climbing Lions',
    'Lake Manyara Map'
  ];

  paragraphs = [
    `<p class="generated-p">
“Look to your right...” whispers your Kopa tour guide as they point out a large family of
  elephants congregating at the stream. You pull up inches from the elephants and watch in
  amazement as they splash heaps of mud onto their leathery backs. Welcome to the “mud splash
  zone,” only here at Lake Manyara do intimate animal interactions like this happen regularly.
</p>`,
    `<p class="generated-p">
                        Lake Manyara allows for an excellent day trip. With the park being only 125 square miles,
                        mammals are densely populated -- it feels like animal encounters are non-stop. Further, most of
                        the park’s terrain is forest. It is not uncommon for an elephant bull to come bursting out of
                        the brush, blocking your safari vehicle’s path! Be sure to scan the treelines, the park is
                        famous for its rare tree climbing lions. Primates love trees, you will also see troops of
                        baboons on the regular.
                    </p>`,
    `<p class="generated-p">
                        You will encounter breathtaking scenery as you drive through Lake Manyara’s 11 astonishing
                        ecosystems all in one day! As you drive around the fringe of the soda-ash Lake Manyara, you will
                        see literally millions of bright, pink flamingos (fun fact, a group of flamingos is called a
                        “flamboyance”!). Interspersed with the flamingos, you will also see 350+ other rare bird
                        species. This is THE PARK to visit for bird-lovers. Lake Manyara is less crowded than other
                        parks, so you can get up close and personal with the wildlife. This is not a park you want to
                        miss!
                    </p>`,
    `<p class="generated-p">
        Lake Manyara is perhaps best known for its famous Tree Climbing Lions. The vast majority of Lions in Tanzania
        are adapted to the plains that cover most of the country's wilderness, such as the
        <a class="generated-a" href="../../national-parks/serengeti">Serengeti</a> plains. Therefore, most Lions spend their time
        on the ground, or even laying in the road in these other parks. That's what makes Lake Manyara's Lions so unique. Lions do
        climb trees elsewhere in the world, but rarely will you see Lions in trees as opposed to on the ground. Lake Manyara gives
        you the chance these other parks do not. If you see Lions in Lake Manyara National Park, consider it a unique treat!
    </p>`,
    `<p class="generated-p">
        Lake Manyara National Park is located about 30 miles southeast of the entrance to <a class="generated-a" href="../../national-parks/ngorongoro">Ngorongoro Conservation Area</a>.
        Despite the close proximity to Ngorongoro, Lake Manyara gives a vastly different feel. It is located just beneath a massive
        mountain range that signifies a piece of the Great Rift Valley. The mountains you will see at Lake Manyara are incredibly beautiful,
        and give the park the true feel of wilderness. After completing your safari through Lake Manyara National Park, you will travel up this mountain range,
        which you will discover is actually a plateau on which Tanzania's most famous lands reside, namely:
        <ul>
        <li>Tanzanian Coffee Country</li>
        <li><a class="generated-a" href="../../national-parks/ngorongoro">Ngorongoro Crater</a></li>
        <li><a class="generated-a" href="../../national-parks/serengeti">Serengeti National Park</a></li>
        </ul>
        Lake Manyara is one of the lesser known parks in Tanzania, but it will certainly be one of your favorites by the end of your trip,
        due to its plentiful wildlife, and its beautiful natural scenery.
    </p>`

  ];

  factsHeader = 'Lake Manyara Facts';
  facts = [
    'When full, the lake takes over 2/3 of the park!\n',
    `Over 670 plant species and 350 bird species have been recorded here.`,
    `Baboon families run rampant here. Rival Baboon gangs are often recorded having territory wars.`,
    `During the dry season, the lake accommodates millions of Flamingos, and massive Pelicans.`,
    'The park has many environments on display, including forest, plains, and marsh areas that each contain a unique group of wildlife.'
  ];
  badge = `<i><span class="badge badge-secondary px-2 py-1">Home of Tree Climbing Lions</span></i>`;
}
